import React from 'react';
import { TrendingUp, AlertTriangle } from 'lucide-react';

const TradingStrategySection = ({ 
  formData, 
  handleInputChange, 
  errors,
  tradingStrategies
}) => {
  if (!formData.includeTradingStrategy) {
    return (
      <div className="mb-6 bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border border-green-200 dark:border-green-800">
        <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
          <TrendingUp className="w-5 h-5 mr-2 text-green-500" />
          Торговая стратегия
        </h3>
        
        <div className="mb-2">
          <div className="flex items-start">
            <div className="flex items-center h-5">
              <input
                id="includeTradingStrategy"
                name="includeTradingStrategy"
                type="checkbox"
                checked={formData.includeTradingStrategy}
                onChange={handleInputChange}
                className="form-checkbox"
              />
            </div>
            <div className="ml-3 text-sm">
              <label htmlFor="includeTradingStrategy" className="font-medium text-gray-700 dark:text-gray-300">
                Учитывать торговую стратегию
              </label>
              <p className="text-gray-500 dark:text-gray-400">
                Различные торговые стратегии имеют разный потенциал доходности и уровень риска
              </p>
            </div>
          </div>
          {errors.includeTradingStrategy && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.includeTradingStrategy}
            </p>
          )}
        </div>
      </div>
    );
  }

  // Получение выбранной стратегии для отображения деталей
  const selectedStrategy = tradingStrategies.find(s => s.id === formData.tradingStrategy) || tradingStrategies[0];

  return (
    <div className="mb-6 bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border border-green-200 dark:border-green-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <TrendingUp className="w-5 h-5 mr-2 text-green-500" />
        Торговая стратегия
      </h3>
      
      <div className="mb-2">
        <div className="flex items-start">
          <div className="flex items-center h-5">
            <input
              id="includeTradingStrategy"
              name="includeTradingStrategy"
              type="checkbox"
              checked={formData.includeTradingStrategy}
              onChange={handleInputChange}
              className="form-checkbox"
            />
          </div>
          <div className="ml-3 text-sm">
            <label htmlFor="includeTradingStrategy" className="font-medium text-gray-700 dark:text-gray-300">
              Учитывать торговую стратегию
            </label>
            <p className="text-gray-500 dark:text-gray-400">
              Различные торговые стратегии имеют разный потенциал доходности и уровень риска
            </p>
          </div>
        </div>
        {errors.includeTradingStrategy && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.includeTradingStrategy}
          </p>
        )}
      </div>

      {/* Выбор стратегии */}
      <div className="mt-4">
        <label htmlFor="tradingStrategy" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Выберите стратегию
        </label>
        <select
          id="tradingStrategy"
          name="tradingStrategy"
          value={formData.tradingStrategy}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.tradingStrategy ? 'input-error' : ''}`}
        >
          {tradingStrategies.map((strategy) => (
            <option key={strategy.id} value={strategy.id}>
              {strategy.name}
            </option>
          ))}
        </select>
        {errors.tradingStrategy && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.tradingStrategy}
          </p>
        )}
      </div>

      {/* Описание выбранной стратегии */}
      <div className="mt-3 p-3 bg-white dark:bg-gray-800 rounded-lg border border-green-100 dark:border-green-900">
        <h4 className="text-sm font-medium text-gray-800 dark:text-gray-200 mb-1">
          {selectedStrategy.name}
        </h4>
        <p className="text-xs text-gray-600 dark:text-gray-400 mb-2">
          {selectedStrategy.description}
        </p>
        
        {/* Индикатор риска */}
        <div className="mt-2">
          <div className="flex justify-between text-xs text-gray-500 dark:text-gray-400 mb-1">
            <span>Уровень риска:</span>
            <span className={
              selectedStrategy.riskScore < 70 
                ? "text-green-500 dark:text-green-400 font-medium" 
                : selectedStrategy.riskScore < 85 
                  ? "text-yellow-500 dark:text-yellow-400 font-medium"
                  : "text-red-500 dark:text-red-400 font-medium"
            }>
              {selectedStrategy.riskScore < 70 ? "Низкий" : 
               selectedStrategy.riskScore < 85 ? "Средний" : "Высокий"} 
              ({selectedStrategy.riskScore}/100)
            </span>
          </div>
          <div className="relative w-full h-2">
            <div className="risk-meter w-full"></div>
            <div className="risk-indicator" style={{ left: `${selectedStrategy.riskScore}%` }}></div>
          </div>
        </div>
      </div>

      {selectedStrategy.riskScore >= 85 && (
        <div className="mt-3 p-3 bg-yellow-50 dark:bg-yellow-900/30 rounded-lg border border-yellow-200 dark:border-yellow-800 flex items-start">
          <AlertTriangle className="w-4 h-4 text-yellow-500 mt-0.5 mr-2 flex-shrink-0" />
          <p className="text-xs text-yellow-700 dark:text-yellow-300">
            Внимание! Выбранная стратегия имеет высокий уровень риска. Рекомендуется использовать только опытным трейдерам и для небольшой части портфеля.
          </p>
        </div>
      )}
    </div>
  );
};

export default TradingStrategySection;